import { Authentication } from "../authentication";
import { StoredAuthentication } from "../stored-authentication";

/**
 * Defines members for mapping from an authentication to a stored authentication.
 */
export abstract class MapAuthenticationToStoredAuthentication {
	/**
	 * Maps the specified authentication into a stored authentication for storage.
	 * @param authentication The authentication to map into a stored authentication.
	 * @returns A new instance of the stored authentication.
	 */
	public static Map(authentication: Authentication): StoredAuthentication {
		return {
			IsAuthenticated: authentication.IsAuthenticated,
			IsLockedOut: authentication.IsLockedOut,
			UserName: authentication.UserName,
			Email: authentication.Email
		};
	}
}